import { render, staticRenderFns } from "./LcaDetailHeader.vue?vue&type=template&id=0fa45331"
import script from "./LcaDetailHeader.vue?vue&type=script&lang=js"
export * from "./LcaDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports